import { StyleSheet } from "@react-pdf/renderer";

/**
 * PDF styles for the license document.
 * These styles are used to format the PDF content generated by react-pdf.
 *
 * @module PDF_LICENSE_STYLES
 */
export const PDF_LICENSE_STYLES = StyleSheet.create({
  page: {
    paddingVertical: 40,
    paddingHorizontal: 50,
    fontSize: 11,
    fontFamily: "Helvetica",
    lineHeight: 1.5,
  },

  section: {
    marginBottom: 20,
  },

  header: {
    fontSize: 20,
    textAlign: "center",
    fontWeight: "bold",
    marginBottom: 30,
    textTransform: "uppercase",
  },

  bold: {
    fontWeight: "bold",
  },

  semibold: {
    fontWeight: "600",
  },

  underline: {
    textDecoration: "underline",
  },

  italic: {
    fontStyle: "italic",
  },

  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 10,
  },

  line: {
    marginBottom: 8,
  },

  horizontalSpace: {
    marginRight: 12,
  },

  h1: {
    fontSize: 18,
    fontWeight: "bold",
    marginBottom: 12,
  },

  h2: {
    fontSize: 16,
    fontWeight: "600",
    marginBottom: 10,
  },

  h3: {
    fontSize: 14,
    fontWeight: "600",
    marginBottom: 8,
  },

  h4: {
    fontSize: 12,
    fontWeight: "600",
    marginBottom: 6,
  },

  h5: {
    fontSize: 10,
    fontWeight: "600",
    marginBottom: 4,
  },

  paragraph: {
    marginBottom: 10,
    textAlign: "justify",
  },

  smallText: {
    fontSize: 9,
    color: "#555",
  },

  signatureBlock: {
    marginTop: 40,
    flexDirection: "row",
    justifyContent: "space-between",
  },

  signatureLine: {
    borderBottomWidth: 1,
    borderColor: "#000",
    width: 200,
    marginTop: 30,
  },

  // List styles
  listItem: {
    flexDirection: "row",
    marginBottom: 6,
    marginLeft: 10,
  },

  listBullet: {
    width: 20,
    textAlign: "right",
    paddingRight: 5,
  },

  listContent: {
    flex: 1,
    textAlign: "left",
    flexWrap: "wrap",
  },

  nestedListItem: {
    marginLeft: 20,
    marginBottom: 4,
  },

  nestedListItemLevel2: {
    marginLeft: 40,
    marginBottom: 4,
  },

  nestedListItemLevel3: {
    marginLeft: 60,
    marginBottom: 4,
  },
});
